import React, { useEffect } from 'react';
// import "bootstrap/dist/css/bootstrap.css";
// import "react-bootstrap-carousel/dist/react-bootstrap-carousel.css";
// import moment from 'moment';
import './../../webcss/default.css';
import './../../webcss/styles.css';
import Header from './header';
import Footer from './footer';

function PrivacyPolicy() {

    useEffect(() => {
        // setReportMode(Apps);
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div>
                <Header />
                <div>
                    <div className="notice-section notice-section-sm border-top red">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-10 col-sm-10 col-12">
                                    <div className="mt-5">
                                        <h6 className="fontwhite">Become a SR PAY Private Limited Franchise &amp; Grow your income 30% to 50% per month
                                        </h6>
                                    </div>
                                </div>
                                <div className="col-md-2 col-sm-2 col-12">
                                    <div className="right-holder-md">
                                        <a href="/joinus" className="primary-button button-lg mt-15-xs bluebtn">Join Now</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-title-section">
                        <div className="container">
                            <h1>Privacy <span className="white"> Policy</span></h1>
                        </div>
                    </div>
                    <div className>
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-12">
                                    <div className="pl-30-md mt-40">
                                        <div className="text-content-big mt-20">

                                            <h5><b>1. INTRODUCTION</b></h5>
                                            <p>Welcome to SR PAY Private Limited ("SR PAY", "Company", "we", "our", or "us").</p>
                                            <p>SR PAY is committed to protecting the privacy and security of the personal information entrusted to us by our customers, merchants, business partners, website visitors, and users of our mobile applications and services.</p>
                                            <p>This Privacy Policy explains how we collect, use, process, store, share, and protect your information when you access or use our website, mobile application, products, and services.</p>
                                            <p>By accessing, registering, or using any SR PAY service, you acknowledge that you have read, understood, and agreed to the terms of this Privacy Policy.</p>
                                            <p>If you do not agree with any part of this Privacy Policy, please discontinue use of our services.</p>
                                            <br />

                                            <h5><b>2. ABOUT SR PAY</b></h5>
                                            <p>SR PAY Private Limited provides technology-enabled financial service facilitation through authorized partner banks, regulated financial institutions, payment service providers, and other authorized ecosystem participants.</p>
                                            <p>Our services may include:</p>
                                            <ul className="details">
                                                <li>BBPS Services</li>
                                                <li>AEPS Services</li>
                                                <li>Domestic Money Transfer (DMT)</li>
                                                <li>Cash Management Services (CMS)</li>
                                                <li>Merchant Payment Services</li>
                                                <li>Utility Bill Payments</li>
                                                <li>Recharge Services</li>
                                                <li>Financial Inclusion Services</li>
                                                <li>Other digital financial services introduced from time to time</li>
                                            </ul>
                                            <p>SR PAY does not function as a bank and provides services through authorized partners and regulated entities wherever applicable.</p>
                                            <br />

                                            <h5><b>3. INFORMATION WE COLLECT</b></h5>
                                            <p>To provide our services efficiently and comply with applicable laws and regulatory requirements, we may collect the following categories of information.</p>
                                            <p><b>A. Personal Information</b></p>
                                            <ul className="details">
                                                <li>Full Name</li>
                                                <li>Father's Name</li>
                                                <li>Date of Birth</li>
                                                <li>Gender</li>
                                                <li>Residential Address</li>
                                                <li>Business Address</li>
                                                <li>Mobile Number</li>
                                                <li>Email Address</li>
                                                <li>Photograph</li>
                                                <li>PAN Details</li>
                                                <li>Aadhaar Details (where permitted by law)</li>
                                                <li>GST Information</li>
                                                <li>Business Registration Information</li>
                                                <li>Other KYC Documents</li>
                                            </ul>
                                            <p><b>B. Financial Information</b></p>
                                            <ul className="details">
                                                <li>Bank Account Details</li>
                                                <li>IFSC Codes</li>
                                                <li>Transaction Information</li>
                                                <li>Beneficiary Information</li>
                                                <li>Settlement Information</li>
                                                <li>Merchant Account Details</li>
                                                <li>Payment Records</li>
                                            </ul>
                                            <p><b>C. Technical Information</b></p>
                                            <p>When you access our website or mobile application, we may automatically collect:</p>
                                            <ul className="details">
                                                <li>Device Information</li>
                                                <li>Device Model</li>
                                                <li>Operating System</li>
                                                <li>Browser Information</li>
                                                <li>IP Address</li>
                                                <li>Device Identifier</li>
                                                <li>Login Information</li>
                                                <li>Network Information</li>
                                                <li>Application Version</li>
                                                <li>Session Information</li>
                                            </ul>
                                            <p><b>D. Location Information</b></p>
                                            <p>Subject to your permission and device settings, we may collect location information for:</p>
                                            <ul className="details">
                                                <li>Fraud Prevention</li>
                                                <li>Transaction Security</li>
                                                <li>Regulatory Compliance</li>
                                                <li>Service Availability Verification</li>
                                            </ul>
                                            <p>You may withdraw location permissions through your device settings; however, certain services may become unavailable.</p>
                                            <p><b>E. Customer Support Information</b></p>
                                            <p>When you contact us, we may collect:</p>
                                            <ul className="details">
                                                <li>Support Requests</li>
                                                <li>Complaint Details</li>
                                                <li>Emails</li>
                                                <li>Call Records</li>
                                                <li>Communication History</li>
                                            </ul>
                                            <br />

                                            <h5><b>4. HOW WE COLLECT INFORMATION</b></h5>
                                            <p>We may collect information through:</p>
                                            <ul className="details">
                                                <li>Website Registration</li>
                                                <li>Mobile Application Registration</li>
                                                <li>Merchant On boarding</li>
                                                <li>KYC Verification Processes</li>
                                                <li>Customer Support Interactions</li>
                                                <li>Service Transactions</li>
                                                <li>Partner Institutions</li>
                                                <li>Regulatory Compliance Processes</li>
                                            </ul>
                                            <br />

                                            <h5><b>5. PURPOSE OF COLLECTION AND USE</b></h5>
                                            <p>Your information may be used for the following purposes:</p>
                                            <p><b>Service Delivery</b></p>
                                            <ul className="details">
                                                <li>Creating and maintaining user accounts</li>
                                                <li>Providing requested services</li>
                                                <li>Processing transactions</li>
                                                <li>Settlement and reconciliation</li>
                                            </ul>
                                            <p><b>Verification and Compliance</b></p>
                                            <ul className="details">
                                                <li>KYC Verification</li>
                                                <li>Identity Authentication</li>
                                                <li>AML Monitoring</li>
                                                <li>Regulatory Reporting</li>
                                                <li>Risk Assessment</li>
                                            </ul>
                                            <p><b>Security and Fraud Prevention</b></p>
                                            <ul className="details">
                                                <li>Detecting fraudulent activities</li>
                                                <li>Preventing unauthorized access</li>
                                                <li>Transaction monitoring</li>
                                                <li>Security investigations</li>
                                            </ul>
                                            <p><b>Customer Support</b></p>
                                            <ul className="details">
                                                <li>Resolving complaints</li>
                                                <li>Providing technical support</li>
                                                <li>Service communications</li>
                                            </ul>
                                            <p><b>Business Operations</b></p>
                                            <ul className="details">
                                                <li>Service improvement</li>
                                                <li>Performance monitoring</li>
                                                <li>Internal auditing</li>
                                                <li>Compliance management</li>
                                            </ul>
                                            <p><b>Legal Obligations</b></p>
                                            <ul className="details">
                                                <li>Compliance with applicable laws</li>
                                                <li>Responding to lawful requests</li>
                                                <li>Regulatory reporting requirements</li>
                                            </ul>
                                            <br />

                                            <h5><b>6. LEGAL BASIS FOR PROCESSING</b></h5>
                                            <p>SR PAY processes personal information based on:</p>
                                            <ul className="details">
                                                <li>User Consent</li>
                                                <li>Performance of Contractual Obligations</li>
                                                <li>Compliance with Legal Requirements</li>
                                                <li>Regulatory Obligations</li>
                                                <li>Legitimate Business Interests</li>
                                                <li>Fraud Prevention and Security Requirements</li>
                                            </ul>
                                            <br />

                                            <h5><b>7. INFORMATION SHARING AND DISCLOSURE</b></h5>
                                            <p>SR PAY does not sell, rent, or trade personal information to third parties.</p>
                                            <p>We may share information only when necessary with:</p>
                                            <p><b>Financial Ecosystem Participants</b></p>
                                            <ul className="details">
                                                <li>Partner Banks</li>
                                                <li>Financial Institutions</li>
                                                <li>Payment Service Providers</li>
                                                <li>BBPS Ecosystem Participants</li>
                                                <li>Settlement Partners</li>
                                            </ul>
                                            <p><b>Verification and Compliance Agencies</b></p>
                                            <ul className="details">
                                                <li>KYC Verification Agencies</li>
                                                <li>Identity Verification Service Providers</li>
                                                <li>Risk Assessment Agencies</li>
                                                <li>Fraud Monitoring Agencies</li>
                                            </ul>
                                            <p><b>Regulatory and Government Authorities</b></p>
                                            <ul className="details">
                                                <li>RBI</li>
                                                <li>NPCI</li>
                                                <li>Law Enforcement Agencies</li>
                                                <li>Government Authorities</li>
                                                <li>Courts and Tribunals</li>
                                                <li>Statutory Authorities</li>
                                            </ul>
                                            <p><b>Professional Service Providers</b></p>
                                            <ul className="details">
                                                <li>Auditors</li>
                                                <li>Legal Advisors</li>
                                                <li>Compliance Consultants</li>
                                            </ul>
                                            <p>Information is shared only on a need-to-know basis and subject to appropriate safeguards.</p>
                                            <br />

                                            <h5><b>8. FRAUD PREVENTION AND RISK MANAGEMENT</b></h5>
                                            <p>To protect users and maintain the integrity of our services, SR PAY may:</p>
                                            <ul className="details">
                                                <li>Monitor transactions</li>
                                                <li>Verify identities</li>
                                                <li>Analyse account activity</li>
                                                <li>Detect suspicious patterns</li>
                                                <li>Investigate unauthorized activities</li>
                                                <li>Report suspicious transactions where required by law</li>
                                            </ul>
                                            <p>Users agree that such monitoring may be necessary for regulatory and security purposes.</p>
                                            <br />

                                            <h5><b>9. DATA SECURITY</b></h5>
                                            <p>SR PAY implements reasonable technical, physical, and organizational safeguards to protect personal information.</p>
                                            <p>Security measures may include:</p>
                                            <ul className="details">
                                                <li>SSL Encryption</li>
                                                <li>Secure Data Transmission</li>
                                                <li>Access Controls</li>
                                                <li>Role-Based Access Management</li>
                                                <li>Password Protection</li>
                                                <li>Security Monitoring Systems</li>
                                                <li>Audit Logs</li>
                                                <li>Periodic Security Assessments</li>
                                            </ul>
                                            <p>Despite our efforts, no system can guarantee absolute security.</p>
                                            <br />

                                            <h5><b>10. DATA RETENTION</b></h5>
                                            <p>We retain personal information only for as long as necessary to:</p>
                                            <ul className="details">
                                                <li>Provide services</li>
                                                <li>Maintain business records</li>
                                                <li>Comply with regulatory obligations</li>
                                                <li>Prevent fraud</li>
                                                <li>Resolve disputes</li>
                                                <li>Enforce legal rights</li>
                                            </ul>
                                            <p>Information may be retained for extended periods where required under applicable laws, regulatory directions, investigations, audits, or court proceedings.</p>
                                            <br />

                                            <h5><b>11. COOKIES AND SIMILAR TECHNOLOGIES</b></h5>
                                            <p>Our website may use cookies and similar technologies to:</p>
                                            <ul className="details">
                                                <li>Improve website functionality</li>
                                                <li>Maintain user sessions</li>
                                                <li>Enhance user experience</li>
                                                <li>Analyse website performance</li>
                                            </ul>
                                            <p>Users may disable cookies through browser settings; however, certain features may not function properly.</p>
                                            <br />

                                            <h5><b>12. USER RIGHTS</b></h5>
                                            <p>Subject to applicable laws, users may:</p>
                                            <ul className="details">
                                                <li>Access their personal information</li>
                                                <li>Correct inaccurate information</li>
                                                <li>Update account details</li>
                                                <li>Request information about processing activities</li>
                                                <li>Withdraw consent where legally permissible</li>
                                                <li>Request deletion where retention is not legally required</li>
                                            </ul>
                                            <p>Requests may be submitted through our official support channels.</p>
                                            <br />

                                            <h5><b>13. THIRD-PARTY LINKS</b></h5>
                                            <p>Our website or mobile application may contain links to third-party websites or services.</p>
                                            <p>SR PAY is not responsible for the privacy practices, content, or policies of third-party platforms. Users should review their privacy policies independently.</p>
                                            <br />

                                            <h5><b>14. CHILDREN'S PRIVACY</b></h5>
                                            <p>SR PAY services are intended only for individuals who are legally eligible to enter into binding agreements and use financial services.</p>
                                            <p>We do not knowingly collect personal information from individuals below 18 years of age.</p>
                                            <br />

                                            <h5><b>15. CROSS-BORDER DATA PROCESSING</b></h5>
                                            <p>Where permitted by applicable laws, information may be processed, stored, or accessed through service providers located in other jurisdictions, subject to appropriate security and contractual safeguards.</p>
                                            <br />

                                            <h5><b>16. POLICY UPDATES</b></h5>
                                            <p>SR PAY reserves the right to amend, modify, or update this Privacy Policy at any time.</p>
                                            <p>Changes will be published on our website and mobile application. Continued use of our services after publication of changes constitutes acceptance of the revised Privacy Policy.</p>
                                            <br />

                                            <h5><b>17. CONTACT US</b></h5>
                                            <p>For questions, requests, concerns, or privacy-related inquiries, please contact:</p>
                                            <p><b>SR PAY Private Limited</b><br />
                                            Registered Office:<br />
                                            Plot No. 79, Sukhija Vihar, B Block,<br />
                                            Gandhi Path West, Vaishali Nagar,<br />
                                            Jaipur, Rajasthan – 302021, Rajasthan, India<br />
                                            Email: support@srpay.co.in<br />
                                            Website: www.srpay1.com</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    )
}

export default PrivacyPolicy;